let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2M8g7")).then(() => parcelRequire('gyRwx'));